import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import {
  ThunderboltFilled,
  ThunderboltOutlined,
  DownOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons';
import { openModal, selectViewMode } from '../../redux/store/ui/common';
import { ViewMode } from '../../hooks/viewMode';
import { BULK_ARCHIVE_DRAWER, BULK_CREATE_DRAWER } from './constants';
import { makeT } from './messages';
import { triggerStyles } from './BulkActions.styles';

const BulkActionsButton: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const viewMode = useSelector(selectViewMode);
  const node = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const t = makeT(intl);

  const handleClickOutside = (e: MouseEvent) => {
    if (node.current && !node.current.contains(e.target as Node)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (viewMode !== ViewMode.USERS) return null;

  const openBulkArchive = () => {
    setOpen(false);
    dispatch(openModal(BULK_ARCHIVE_DRAWER));
  };

  const openBulkCreate = () => {
    setOpen(false);
    dispatch(openModal(BULK_CREATE_DRAWER));
  };

  return (
    <>
      <div className="ba-wrapper" ref={node}>
        <div
          data-testid="BulkActions-triggerButton"
          className="ba-button"
          onClick={() => setOpen((v) => !v)}
        >
          <img alt="checklist" src="/images/checklist.png" className="icon" />
          <span>{t('fleetadmin.bulk.actions.button')}</span>
          <DownOutlined className="ba-caret" />
        </div>

        {open && (
          <div className="ba-panel">
            <p className="ba-panel-title">
              {t('fleetadmin.bulk.actions.choose')}
            </p>

            <div
              className="ba-item"
              data-testid="BulkActions-bulkCreate"
              onClick={openBulkCreate}
            >
              <img alt="groupAdd" src="/images/groupAdd.png" className="icon" />
              <div>
                <div className="ba-item-title">
                  {t('fleetadmin.bulk.create.title')}
                </div>
              </div>
            </div>

            <div
              className="ba-item"
              data-testid="BulkActions-bulkArchive"
              onClick={openBulkArchive}
            >
              <img alt="groupOff" src="/images/groupOff.png" className="icon" />
              <div>
                <div className="ba-item-title">
                  {t('fleetadmin.bulk.archive.title')}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <style jsx>{triggerStyles}</style>
    </>
  );
};

export default BulkActionsButton;
